module.exports = __webpack_public_path__ + "img/nojob.19688b6a.svg";